module.exports = __webpack_public_path__ + "static/media/learn-code.8259b619.png";